export default __webpack_public_path__ + "static/media/megafono.54f24074.svg";